import React, { useState, useEffect } from 'react';
import style from './style.module.css';

import { Link } from 'react-router-dom';

import { 
    getLanguageShortname, Language, 
    getLanguageArray, systemLanguage, getLabel,
    organizationsLabel,
    getOrganizations,
    Organization,
    shortname
} from '../../utils/constants';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

const Organizations: React.FC = () => {

    const [sessionLang, setSessionLang] = useState<Language>(getLanguageArray());

    const [userLanguage, setUserLanguage] = useState<{ short: string | any } | false>(false);
    const user_language = getLanguageShortname();

    const organizations = getOrganizations()

    useEffect(() => {
        if (user_language) {
            setUserLanguage({ short: user_language.toUpperCase() });
        } else {
            setUserLanguage({ short: ((user_language as unknown) as Language).short || 'EN' });
        }
    }, [user_language]);

    useEffect(() => {
        window.scrollTo(0,0);
    }, []);

    useEffect(() => {
        const handler = (e: StorageEvent) => {
            if (e.key === systemLanguage && e.newValue) {
                setSessionLang(JSON.parse(e.newValue));
            }
        };
        window.addEventListener("storage", handler);
        return () => window.removeEventListener("storage", handler);
    }, []);

    return (
        <div className={style.scoreboard}>
            <div className={`${style.header} ${style.spaceBottom}`}>
                 <div className={style.headerLeft}>
                    <div className={`${style.greeting} ${style.textContainerGrad}`}>
                        {getLabel(organizationsLabel, sessionLang)}
                    </div>
                </div><div className={style.headerRight}>
                    <Link to={'/organization/create'}>Create Organization</Link>
                </div>
            </div>
            <div className={style.tableWrap}>
                <div className={`${style.tableRow} ${style.header}`}>
                    <div className={`${style.tableCol} ${style.shortname}`}></div><div className={`${style.tableCol} ${style.name}`}>
                        Name
                    </div><div className={`${style.tableCol} ${style.users}`}>
                        Users
                    </div><div className={`${style.tableCol} ${style.address}`}>
                        Address
                    </div><div className={`${style.tableCol} ${style.postal}`}>
                        Postal Code
                    </div><div className={`${style.tableCol} ${style.shortname}`}></div>
                </div>
                {organizations?.map((org: Organization) => (
                    <div className={style.tableRow} key={org.id}>
                        <div className={`${style.tableCol} ${style.shortname}`}>
                            <span>{org.shortname}</span>    
                        </div><div className={`${style.tableCol} ${style.name}`}>
                            <Link to={'/organization/' + org.id}>{org.name}</Link>
                            <span>{org.website}</span>
                        </div><div className={`${style.tableCol} ${style.users}`}>
                            {org.user_count}
                        </div><div className={`${style.tableCol} ${style.address}`}>
                            {org.address}
                        </div><div className={`${style.tableCol} ${style.postal}`}>
                            {org.postal_code}
                        </div><div className={`${style.tableCol} ${style.shortname} ${style.actions}`}>
                            <Link to={'/organization/' + org.id + '/edit'} title={'Edit Organization'}>
                                <FontAwesomeIcon icon={faEdit} />
                            </Link>
                        </div>
                    </div>
                ))}

            </div>
        </div>
    );
}

export default Organizations;
